import LegalLayout, { Section } from "./LegalLayout";

export default function UmowaPowierzenia() {
  return (
    <LegalLayout
      title="Umowa powierzenia przetwarzania danych osobowych (DPA)"
      subtitle="Zawarta pomiędzy Klientem (Administratorem) a Progres (Procesorem)."
      updatedAt="2026-02-08"
      testid="page-dpa"
    >
      <Section heading="§1. Strony">
        <p>
          <strong>Administrator</strong>: użytkownik Serwisu Progres, który wprowadza do
          aplikacji dane osobowe innych osób (np. trener wpisujący dane swoich podopiecznych).
          Jeżeli Klient używa Progres wyłącznie do własnych, osobistych celów, niniejsza umowa
          nie ma zastosowania.
        </p>
        <p>
          <strong>Procesor</strong>: FeGrro Dominik Grzenia, ul. Na Równiku 1, 83-314 Sławki,
          NIP: 5892037971 (dalej: „Progres").
        </p>
      </Section>

      <Section heading="§2. Przedmiot powierzenia">
        <p>
          Administrator powierza Procesorowi przetwarzanie danych osobowych w zakresie
          niezbędnym do świadczenia usług Serwisu Progres, w szczególności: przechowywanie,
          udostępnianie, wyświetlanie i backup.
        </p>
      </Section>

      <Section heading="§3. Charakter, cel i czas przetwarzania">
        <p>
          <strong>Charakter</strong>: przetwarzanie zautomatyzowane w chmurze.
          <br />
          <strong>Cel</strong>: świadczenie usługi Serwisu zgodnie z Regulaminem.
          <br />
          <strong>Czas</strong>: przez okres obowiązywania umowy o świadczenie usług (aktywne
          konto Administratora); po zakończeniu — dane są usuwane w ciągu 30 dni.
        </p>
      </Section>

      <Section heading="§4. Rodzaj danych i kategorie osób">
        <p>
          <strong>Rodzaj danych</strong>: dane identyfikacyjne (imię/pseudonim), parametry
          treningowe, pomiary ciała, statystyki nawyków — wprowadzane przez Administratora.
        </p>
        <p>
          <strong>Kategorie osób</strong>: osoby fizyczne wskazane przez Administratora (np. jego
          podopieczni, klienci trenerscy).
        </p>
      </Section>

      <Section heading="§5. Obowiązki Procesora">
        <p>Procesor zobowiązuje się do:</p>
        <ul className="list-disc pl-6 space-y-1.5">
          <li>przetwarzania danych wyłącznie na udokumentowane polecenie Administratora,</li>
          <li>zapewnienia poufności osobom upoważnionym do przetwarzania,</li>
          <li>
            wdrożenia odpowiednich środków technicznych i organizacyjnych zapewniających
            bezpieczeństwo (szyfrowanie TLS, bcrypt do haseł, backup),
          </li>
          <li>pomocy Administratorowi w realizacji praw osób, których dane dotyczą,</li>
          <li>
            zgłaszania Administratorowi naruszeń ochrony danych w terminie <strong>72 godzin</strong>{" "}
            od ich stwierdzenia,
          </li>
          <li>
            usunięcia lub zwrotu danych po zakończeniu świadczenia usług — zgodnie z wyborem
            Administratora.
          </li>
        </ul>
      </Section>

      <Section heading="§6. Podpowierzenie">
        <p>
          Administrator wyraża ogólną zgodę na korzystanie przez Procesora z podprzetwarzających.
          Aktualna lista podprocesorów obejmuje:
        </p>
        <ul className="list-disc pl-6 space-y-1.5">
          <li>
            <strong>Resend Inc.</strong> (San Francisco, USA) — wysyłka e-maili transakcyjnych.
            Podstawa: SCC (standardowe klauzule umowne).
          </li>
          <li>
            <strong>PayPro S.A.</strong> (Poznań, Polska) — obsługa płatności (Przelewy24).
          </li>
          <li>
            <strong>Dostawca infrastruktury chmurowej</strong> — hosting aplikacji i baz danych
            w obrębie EOG.
          </li>
        </ul>
        <p>
          O każdej zmianie na liście podprocesorów Procesor informuje Administratora z 14-dniowym
          wyprzedzeniem e-mailem. Administrator ma prawo wnieść sprzeciw, co skutkuje możliwością
          rozwiązania niniejszej umowy.
        </p>
      </Section>

      <Section heading="§7. Środki techniczne i organizacyjne">
        <ul className="list-disc pl-6 space-y-1.5">
          <li>transport TLS 1.2+ (HTTPS wymuszone dla całego ruchu),</li>
          <li>hasła użytkowników zabezpieczone algorytmem bcrypt,</li>
          <li>izolacja danych pomiędzy kontami klientów (multi-tenant przez user_id),</li>
          <li>codzienne kopie zapasowe (30-dniowa retencja),</li>
          <li>logowanie zdarzeń administracyjnych,</li>
          <li>ograniczony dostęp do środowiska produkcyjnego (tylko Administrator serwisu).</li>
        </ul>
      </Section>

      <Section heading="§8. Audyt">
        <p>
          Administrator ma prawo — po uprzednim uzgodnieniu, nie częściej niż raz w roku — do
          otrzymania raportu ze stanu wdrożonych środków bezpieczeństwa. W szczególnie
          uzasadnionych przypadkach (np. wskazanie na naruszenie) Administrator może żądać audytu
          na koszt własny.
        </p>
      </Section>

      <Section heading="§9. Odpowiedzialność">
        <p>
          Każda ze stron odpowiada za szkody wynikające z naruszenia niniejszej Umowy oraz
          przepisów o ochronie danych osobowych na zasadach ogólnych. Odpowiedzialność
          Procesora względem Administratora jest ograniczona do wysokości opłat wniesionych
          przez Administratora w ciągu ostatnich 12 miesięcy.
        </p>
      </Section>

      <Section heading="§10. Postanowienia końcowe">
        <p>
          Umowa jest zawierana z chwilą akceptacji podczas rejestracji konta i obowiązuje przez
          okres świadczenia usług. Zmiany Umowy wymagają formy pisemnej (dopuszczalna jest forma
          elektroniczna) i zostaną zakomunikowane e-mailem z 14-dniowym wyprzedzeniem.
        </p>
      </Section>
    </LegalLayout>
  );
}
